import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

const store = new Vuex.Store({
  namespaced: true,
  state: {
    totalFacturas: 0,
    totalAceptadas: 0,
    totalRechazadas: 0,
    totalEnTramite: 0,
    menuItem: '',
    loading: true,
    facturasDataSource: [],
    factura: '',
    cifs: [],
    proveedores: []
  },
  mutations: {
    setTotalFacturas (state, value) {
      state.totalFacturas = value
    },
    setTotalAceptadas (state, value) {
      state.totalAceptadas = value
    },
    setTotalRechazadas (state, value) {
      state.totalRechazadas = value
    },
    setTotalEnTramite (state, value) {
      state.totalEnTramite = value
    },
    setFacturasDataSource (state, value) {
      state.facturasDataSource = value
      state.totalFacturas = value.length

      const aceptadas = value.filter(function (factura) {
        return (factura.Estado === 'Aceptada')
      })

      const rechazadas = value.filter(function (factura) {
        return (factura.Estado === 'Rechazada')
      })

      const enTramite = value.filter(function (factura) {
        return (factura.Estado === 'En Trámite')
      })

      state.totalAceptadas = aceptadas.length
      state.totalRechazadas = rechazadas.length
      state.totalEnTramite = enTramite.length
    },
    setMenuItem (state, value) {
      state.menuItem = value
    },
    setFactura (state, value) {
      state.factura = value
    },
    setLoading (state, value) {
      state.loading = value
    },
    setCIFs (state)
    {
      state.cifs = []
      state.proveedores = []
      const cifSolpheo = JSON.parse(localStorage.getItem('cifs'))
      cifSolpheo.forEach(element => {
        state.cifs.push(element.CIF)
        state.proveedores.push(element.RazonSocial)
      })
    },
    addFactura (state, value) {
      state.facturasDataSource.unshift(value)

      const aceptadas = state.facturasDataSource.filter(function (factura) {
        return (factura.Estado === 'Aceptada')
      })

      const rechazadas = state.facturasDataSource.filter(function (factura) {
        return (factura.Estado === 'Rechazada')
      })

      const enTramite = state.facturasDataSource.filter(function (factura) {
        return (factura.Estado === 'En Trámite')
      })

      state.totalAceptadas = aceptadas.length
      state.totalRechazadas = rechazadas.length
      state.totalEnTramite = enTramite.length
      state.totalFacturas = state.facturasDataSource.length
    }
  },
  getters: {
    getTotalFacturas (state) {
      return state.totalFacturas
    },
    getFacturasAceptadas (state) {
      return state.totalAceptadas
    },
    getFacturasRechazadas (state) {
      return state.totalRechazadas
    },
    getFacturasEnTramite (state) {
      return state.totalEnTramite
    },
    getFacturas (state) {
      return (estado) => {
        if (estado === 1) {
          state.menuItem = 'Facturas'
          return state.facturasDataSource
        }
        if (estado === 2) {
          state.menuItem = 'Aceptadas'
          return state.facturasDataSource.filter(function (factura) {
            return (factura.Estado === 'Aceptada')
          })
        }
        if (estado === 3) {
          state.menuItem = 'Rechazadas'
          return state.facturasDataSource.filter(function (factura) {
            return (factura.Estado === 'Rechazada')
          })
        }
        if (estado === 4) {
          state.menuItem = 'En Trámite'
          return state.facturasDataSource.filter(function (factura) {
            return (factura.Estado === 'En Trámite')
          })
        }
      }
    },
    getMenuItem (state) {
      return state.menuItem
    },
    getLoading (state) {
      return state.loading
    },
    getCIFs (state) {
      return state.cifs
    } 
  },
  actions: {}
})

export default store
